"use client"

import { indexVar, twoDigit } from "@/components/marketing/landing-v2/cssVars"
import { useReveal } from "@/components/marketing/landing-v2/useReveal"
import type { Landing2Copy } from "@/lib/landing-v2/copy"

/** Four steps in real order, so the connecting rule fills as the section arrives. */
export function ProcessSection({ copy }: { copy: Landing2Copy }) {
  const headRef = useReveal<HTMLElement>()
  const journeyRef = useReveal<HTMLDivElement>()

  return (
    <section className="l2-section" id="how">
      <div className="l2-container">
        <header className="l2-section-head" ref={headRef}>
          <span className="l2-label">{copy.process.label}</span>
          <h2 className="l2-h2">{copy.process.title}</h2>
          <p className="l2-section-sub">{copy.process.subtitle}</p>
        </header>

        <div className="l2-journey-wrap" ref={journeyRef}>
          <i className="l2-journey-rail" aria-hidden="true" />
          <ol className="l2-journey">
            {copy.process.steps.map((step, index) => (
              <li className="l2-step" key={step.title} style={indexVar(index)}>
                <span className="l2-step-node" aria-hidden="true" />
                <span className="l2-step-index">{twoDigit(index + 1)}</span>
                <h3 className="l2-step-title">{step.title}</h3>
                <p className="l2-step-body">{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
